import { LayoutState } from './layout.types';

import { RootState } from '~/redux/store';

export const selectFocusElement = ({
  layout,
}: RootState): LayoutState['focusElement'] => layout.focusElement;
